import common from './_common';

/**
 * input一行フォームにHTML可なplaceholderを表示するコンポーネント
 *
 */
export default {
    // see resources/views/components/_vue_textinput_placeholder.blade.php
    template: '#textinput_placeholder_template',
    mixins: [
        common
    ]
};
